/**
 * 电商详情图 → Seedream 出图尺寸（满足最小像素约束）
 */

/** Seedream 5 等：总像素至少约 3686400（≈1920×1920） */
export const SEEDREAM_MIN_PIXELS = 3686400

export const ECOM_SEEDREAM_SIZE_MAIN = '2048x2048'

export const ECOM_SEEDREAM_SIZE_DETAIL = '1600x2400'

export function resolveEcomSeedreamOutputSize(size, isMain) {
  const s = String(size || '').trim().toLowerCase()
  if (isMain === true || s === '1024x1024' || s === '2048x2048' || s === '1x1') {
    return ECOM_SEEDREAM_SIZE_MAIN
  }
  if (
    isMain === false ||
    s === '1024x1536' ||
    s === '768x1024' ||
    s === '1600x2400' ||
    s === '1536x2048'
  ) {
    return ECOM_SEEDREAM_SIZE_DETAIL
  }
  const m = s.match(/^(\d+)x(\d+)$/)
  if (m) {
    let w = parseInt(m[1], 10)
    let h = parseInt(m[2], 10)
    if (w > 0 && h > 0) {
      const area = w * h
      if (area >= SEEDREAM_MIN_PIXELS) return `${w}x${h}`
      const scale = Math.sqrt(SEEDREAM_MIN_PIXELS / area)
      w = Math.max(1920, Math.round(w * scale))
      h = Math.max(1920, Math.round(h * scale))
      if (w * h < SEEDREAM_MIN_PIXELS) {
        h = Math.ceil(SEEDREAM_MIN_PIXELS / w)
      }
      return `${w}x${h}`
    }
  }
  return isMain === false ? ECOM_SEEDREAM_SIZE_DETAIL : ECOM_SEEDREAM_SIZE_MAIN
}

export function normalizeEcomPromptPlanRow(plan) {
  if (!plan || typeof plan !== 'object') return plan
  const idx = Number(plan.index)
  const isMain = idx >= 1 && idx <= 3
  const raw = String(plan.size || '').trim()
  const resolved = resolveEcomSeedreamOutputSize(raw, isMain)
  return { ...plan, size: resolved, sizeLabel: raw && raw !== resolved ? raw : '' }
}

export function ecomPlanSizeToAspectKey(size) {
  const resolved = resolveEcomSeedreamOutputSize(size)
  if (resolved === ECOM_SEEDREAM_SIZE_MAIN) return '1x1_2k'
  if (resolved === ECOM_SEEDREAM_SIZE_DETAIL) return '2x3_2k'
  const s = resolved.toLowerCase()
  if (s.includes('2048x2048') || s.includes('4096')) return '1x1_2k'
  if (s.includes('2560x1440') || s.includes('1280x720')) return '16x9_2k'
  if (s.includes('1440x2560') || s.includes('720x1280')) return '9x16_2k'
  return '2x3_2k'
}
